import axios from 'axios';
import { resolveTenantHeaderForApi } from "./tenant";

const CACHE_NAME = 'metaDataCache';
const CACHE_NAME_DASBOARD = 'metaDataCacheDasboard';
const CACHE_NAME_COMP = 'metaDataCacheComp';
const CACHE_KEY = 'http://localhost:8080/metaData';
const CACHE_KEY_DASHBOARD = 'http://localhost:8080/metaDataDashboard';
const CACHE_KEY_COMP = 'http://localhost:8080/metaDataComp';

export async function fetchMetaData(explicitTenantId) {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_URL}public/api/configurationsets`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          "X-TenantID": resolveTenantHeaderForApi(explicitTenantId),
        },
      }
    );

    if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
      const tablesData = response.data.data.tables;
      const componentsData = response.data.data.components;
      
      const tablesCache = await caches.open(CACHE_NAME);
      const timestampedTablesData = { data: tablesData, timestamp: new Date().getTime() };
      const tablesCacheResponse = new Response(JSON.stringify(timestampedTablesData), {
        headers: { 'Content-Type': 'application/json' }
      });
      await tablesCache.put(CACHE_KEY, tablesCacheResponse);

      const componentsCache = await caches.open(CACHE_NAME_COMP);
      const timestampedComponentsData = { data: componentsData, timestamp: new Date().getTime() };
      const componentsCacheResponse = new Response(JSON.stringify(timestampedComponentsData), {
        headers: { 'Content-Type': 'application/json' }
      });
      await componentsCache.put(CACHE_KEY_COMP, componentsCacheResponse);

      return tablesData;
    } else {
      throw new Error(`Unexpected status code: ${response.data.statusCode}`);
    }
  } catch (error) {
    console.error("Error fetching metadata:", error);
    throw error;
  }
}
export async function fetchMetaDataForDashboard(explicitTenantId) {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_URL}public/api/tables/type?columns=true`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          "X-TenantID": resolveTenantHeaderForApi(explicitTenantId),
        },
      }
    );

    if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
      const data = response.data.data.tableTypes;
      const cache = await caches.open(CACHE_NAME_DASBOARD);
      const timestampedData = { data, timestamp: new Date().getTime() };
      const cacheResponse = new Response(JSON.stringify(timestampedData), {
        headers: { 'Content-Type': 'application/json' }
      });
      await cache.put(CACHE_KEY_DASHBOARD, cacheResponse);
      return data;
    } else {
      throw new Error(`Unexpected status code: ${response.data.statusCode}`);
    }
  } catch (error) {
    console.error("Error fetching metadata:", error);
    throw error;
  }
}
export async function getCachedMetaData() {
  if (!caches) {
    return null;
  }

  const cache = await caches.open(CACHE_NAME);

  const cachedResponse = await cache.match(CACHE_KEY);
  if (!cachedResponse) {
    return null;
  }

  const cachedData = await cachedResponse.json();
  return cachedData.data;
}

export async function getCachedMetaDataDashboard() {
  if (!caches) {
    return null;
  }

  const cache = await caches.open(CACHE_NAME_DASBOARD);

  const cachedResponse = await cache.match(CACHE_KEY_DASHBOARD);
  if (!cachedResponse) {
    return null;
  }

  const cachedData = await cachedResponse.json();
  return cachedData.data;
}
export async function getCachedMetaComp() {
  if (!caches) {
    return null;
  }

  const cache = await caches.open(CACHE_NAME_COMP);

  const cachedResponse = await cache.match(CACHE_KEY_COMP);
  if (!cachedResponse) {
    return null;
  }

  const cachedData = await cachedResponse.json();
  return cachedData.data;
}
export async function getDisplayName(tableName, fieldName) {
  let metaData = await getCachedMetaData();
  if (!metaData) {
    throw new Error('Metadata not found in cache');
  }

  const table = metaData.find(table => table.test === tableName);
  if (!table) {
    throw new Error(`Table "${tableName}" not found in metadata`);
  }

  const metaDataField = table.metaData?.[fieldName] || null;
  if (metaDataField) {
    return { displayName: metaDataField.displayName, digits: metaDataField.decimals, defaultUOM: metaDataField.defaultUOM };
  }

  throw new Error(`Field "${fieldName}" not found in table "${tableName}"`);
}

export async function getSortOrder(testName, pageGet = null, position) {
  const metaData = await getCachedMetaData();
  if (!metaData) {
    throw new Error('Metadata not found in cache');
  }

  const table = metaData.find(table => table.test === testName);
  if (!table) {
    throw new Error(`Table "${testName}" not found in metadata`);
  }

  const page = table.page.find(tableInside => tableInside.page === pageGet && tableInside.position === position);
  if (!page) {
    throw new Error(`Sort order not found for page "${pageGet}" and position "${position}" in table "${testName}"`);
  }

  return page.sortOrder;
}


export async function getDisplayNameDashboard(tableName, fieldName) {
  let metaData = await getCachedMetaDataDashboard();

  if (!metaData) {
    return { displayName: fieldName, digits: undefined };
  }

  const table = metaData.find(table => table.table === tableName);
  if (!table) {
    return { displayName: fieldName, digits: undefined };
  }

  const field = table.columns.find(column => column.name === fieldName);
  if (!field) {
    return { displayName: fieldName, digits: undefined };
  }

  return { displayName: field.displayName, digits: field.digits };
}

export async function getComponentOrder(componentName) {
  const metaData = await getCachedMetaComp();
  if (!metaData) {
    throw new Error('Metadata not found in cache');
  }

  const component = Object.values(metaData).find(item => item.component === componentName);
  
  if (!component) {
    throw new Error(`Component "${componentName}" not found in metadata`);
  }

  return component.sortOrder;
}